/**
 * Canal de vente d'une commande — le `source_name` Shopify (`01` §7.1,
 * vocabulaire arrêté le 10/09/2026 : « Canal », jamais « source »).
 *
 * Ce registre ne sert qu'aux **suggestions** du formulaire d'opération et à
 * l'affichage : la valeur reste libre côté condition, car Shopify et les
 * applications tierces en inventent régulièrement de nouvelles (`pos`,
 * `shopify_draft_order`, `subscription_contract_checkout_one`…). Un joker de
 * fin (`subscription_*`) couvre toute une famille.
 */
export const ORDER_CHANNELS = [
    'web',
    'tiktok',
    'pos',
    'shopify_draft_order',
    'subscription_*',
];
export const ORDER_CHANNEL = {
    web: { code: 'web', label: 'Boutique en ligne', tone: 'blue' },
    tiktok: { code: 'tiktok', label: 'TikTok Shop', tone: 'blue' },
    pos: { code: 'pos', label: 'Point de vente', tone: 'gray' },
    shopify_draft_order: { code: 'shopify_draft_order', label: 'Commande brouillon', tone: 'gray' },
    'subscription_*': {
        code: 'subscription_*',
        label: 'Abonnement (renouvellement)',
        tone: 'blue',
        description: 'Toutes les commandes dont le canal commence par « subscription_ ».',
    },
};
/** Libellé français d'un canal, ou le code brut pour une valeur libre. */
export function channelLabel(code) {
    return code in ORDER_CHANNEL ? ORDER_CHANNEL[code].label : code;
}
//# sourceMappingURL=channel.js.map